import ShopifyBuy from '@shopify/buy-button-js'

const Client = ShopifyBuy.buildClient({
    domain: ShopifyConfig.domain,
    storefrontAccessToken: ShopifyConfig.storefrontAccessToken
});

const UI = ShopifyBuy.UI.init(Client);

function initShop() {

    let options = {
        moneyFormat: '{{amount_no_decimals}}€',
        productSet: {
            iframe: false
        },
        product: {
            iframe: false,
            variantId: 'all',
            width: '1536',
            order: [
                'title',
                'imgPagination',
                'img',
                'description',
                'options',
                'price',
                'button'
            ],
            contents: {
                description: true,
                img: true,
                imgPagination: true,
                price: false
            },
            classes: {
                button: 'btn btn--yellow order-btn',
                imgPagination: 'shopify-buy__img__pagination'
            },
            templates: {
                title: `<h2 class="shopify-buy__product__title">{{data.title}}</h2>`,
                button:
                    `<div class="shopify-buy__product__details">
                    <div class="{{data.classes.product.prices}}" data-element="product.prices">
                        {{#data.selectedVariant}}
                        <span class="{{data.classes.product.price}} {{data.priceClass}}" data-element="product.price">{{data.formattedPrice}}</span>
                        {{#data.selectedVariant.compareAtPrice}}<span class="{{data.classes.product.compareAt}}" data-element="product.compareAt">{{data.formattedCompareAtPrice}}</span>{{/data.selectedVariant.compareAtPrice}}
                        {{/data.selectedVariant}}
                    </div>
                        <div class="{{data.classes.product.buttonWrapper}}" data-element="product.buttonWrapper"><button {{#data.buttonDisabled}}disabled{{/data.buttonDisabled}} class="{{data.classes.product.button}} {{data.buttonClass}}" data-element="product.button">{{data.buttonText}}</button></div>
                    </div>`,
                price: ``,
                img: `
                    {{#data.currentImage.src}}
                        <div class="{{data.classes.product.imgWrapper}}{{#data.contents.imgPagination}} has-many-images{{/data.contents.imgPagination}}" data-element="product.imgWrapper">
                            {{#data.contents.imgPagination}}
                                <div class="{{data.classes.product.imgPagination}}" data-element="product.imgPagination">{{data.carouselIndex}} / {{data.carouselImages.length}}</div>
                            {{/data.contents.imgPagination}}
                            <img data-element="product.img" class="{{data.classes.product.img}}" src="{{data.currentImage.src}}" />
                        </div>
                    {{/data.currentImage.src}}
                `
            },
            text: {
                button: 'Order',
                outOfStock: 'Out of stock :(',
                unavailable: 'Not available :('
            },
            events: {
                afterInit: function(component) {
                    // do not show pagination if only one image is present
                    if (this.model.images.length === 1) {
                        this.config.product.contents.imgPagination = false;
                    }
                }
            },
            DOMEvents: {
                'click .shopify-buy__product__variant-img': function(evt, target) {
                    this.component.onCarouselChange(1);
                }
            }
        },
        cart: {
            text: {
                title: 'Shopping Cart',
                total: 'Total',
                currency: '€',
                notice: 'Shipping will be added at checkout.',
                button: 'Checkout'
            },
            styles: {
                cart: {
                    "box-shadow": "none",
                    "color": "black"
                },
                close: {
                    "color": "black",
                    "outline": "0"
                },
                title: {
                    "color": "black",
                    "font-weight": "bold",
                    "font-size": "16px"
                },
                subtotalText: {
                    "color": "black",
                    "margin-bottom": "0.5rem",
                    "font-size": "16px",
                    "font-weight": "bold",
                    "text-transform": "none"
                },
                // actually subtotalPrice
                subtotal: {
                    "color": "black",
                    "font-size": "16px",
                    "font-weight": "bold"
                },
                notice: {
                    "border-top": "2px solid black",
                    "color": "black",
                    "font-size": "14px",
                    "font-weight": "bold"
                },
                button: {
                    "background-color": "#FFF43A",
                    "color": "black",
                    "font-size": "16px",
                    "font-weight": "bold",
                    "text-transform": "none",
                    "transition": "background-color .3s ease",
                    ":hover": {
                        "background-color": "rgba(255,244,58,0.6)"
                    }
                }
            }
        },
        lineItem: {
            styles: {
                itemTitle: {
                    "color": "black",
                    "font-size": "14px",
                    "font-weight": "bold"
                },
                price: {
                    "font-size": "16px",
                    "line-height": "2",
                    "color": "black"
                },
                variantTitle: {
                    "font-size": "14px",
                    "color": "black"
                },
                quantityButton: {
                    "width": "30px",
                    "background-color": "#FFF43A",
                    "color": "black",
                    "border-radius": "0",
                    "border-color": "transparent",
                    "transition": "opacity .3s ease",
                    ":hover": {
                        "opacity": "0.75"
                    }
                },
                quantityInput: {
                    "border-color": "transparent",
                    "border-radius": "0",
                    "font-family": "inherit",
                    "font-weight": "bold"
                }
            }
        },
        toggle: {
            styles: {
                toggle: {
                    "background-color": "FFF43A",
                    "color": "black",
                    "font-weight": "bold",
                    "transition": "background-color .3s ease",
                    ":hover": {
                        "background-color": "rgba(255,244,58,0.6)"
                    },
                    ":focus": {
                        "background-color": "rgba(255,244,58,0.6)"
                    }
                },
                iconPath: {
                    "fill": "#000000"
                }
            }
        },
    };

    let $shop = document.getElementById('shop');

    UI.createComponent('collection', {
        id: '33532018806',
        node: $shop,
        moneyFormat: '{{amount_no_decimals}}€',
        options: options
    });
}

// TODO: only call on opt-in
initShop();
